import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Skeleton loading state for a single event card.
 */
export function EventCardSkeleton() {
  return (
    <Card className="bg-slate-600">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-1/3" />
          </div>
          <Skeleton className="w-5 h-5 flex-shrink-0" />
        </div>
      </CardContent>
    </Card>
  );
}

